export default __webpack_public_path__ + "assets/e91ee27193b907d62ecbf97a4110323e.jpg";